import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import HourglassTopOutlinedIcon from '@mui/icons-material/HourglassTopOutlined';
import ReplyOutlinedIcon from '@mui/icons-material/ReplyOutlined';
import type { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/utils/cn';

export type HrWorkflowStatusIconKey = 'pending' | 'approved' | 'rejected' | 'returned';

const WORKFLOW_STATUS_ICONS: Record<HrWorkflowStatusIconKey, ComponentType<{ className?: string }>> = {
  pending: HourglassTopOutlinedIcon,
  approved: CheckCircleOutlineIcon,
  rejected: CancelOutlinedIcon,
  returned: ReplyOutlinedIcon,
};

/** Maps leave, attendance, overtime, and workflow approval codes to a calendar icon. */
export function hrWorkflowStatusIconKey(statusCode?: string | null): HrWorkflowStatusIconKey | null {
  const code = (statusCode ?? '').trim().toUpperCase();
  if (!code) return null;
  if (code === 'RETURNED' || code.includes('RETURN')) return 'returned';
  if (code === 'APPROVED') return 'approved';
  if (code === 'REJECTED' || code === 'CANCELLED') return 'rejected';
  if (
    code === 'PENDING' ||
    code === 'SUBMITTED' ||
    code === 'DRAFT' ||
    code === 'PENDING_APPROVAL' ||
    code === 'ESCALATED'
  ) {
    return 'pending';
  }
  return 'pending';
}

export function HrWorkflowStatusIcon({
  statusCode,
  className,
}: {
  statusCode?: string | null;
  className?: string;
}) {
  const { t } = useTranslation('hr');
  const key = hrWorkflowStatusIconKey(statusCode);
  if (!key) return null;
  const Icon = WORKFLOW_STATUS_ICONS[key];
  return <Icon className={cn('!h-3.5 !w-3.5 shrink-0', className)} aria-label={t(`workflowStatus.${key}`)} />;
}

/** @deprecated Use {@link HrWorkflowStatusIcon} */
export const HrLeaveStatusIcon = HrWorkflowStatusIcon;

/** @deprecated Use {@link hrWorkflowStatusIconKey} */
export const hrLeaveStatusIconKey = hrWorkflowStatusIconKey;

/** @deprecated Use {@link HrWorkflowStatusIconKey} */
export type HrLeaveStatusIconKey = HrWorkflowStatusIconKey;

